import { render, staticRenderFns } from "./AuthorizeForm.vue?vue&type=template&id=fca378ba&scoped=true"
import script from "./AuthorizeForm.vue?vue&type=script&lang=js"
export * from "./AuthorizeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca378ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca378ba')) {
      api.createRecord('fca378ba', component.options)
    } else {
      api.reload('fca378ba', component.options)
    }
    module.hot.accept("./AuthorizeForm.vue?vue&type=template&id=fca378ba&scoped=true", function () {
      api.rerender('fca378ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/online/components/AuthorizeForm.vue"
export default component.exports